import RegistrForm from "../components/RegistrForm/RegistrForm";


const RegistrationPage = () => {
    return (
        <>
            <RegistrForm/>
        </>
    )
};


export default RegistrationPage;